import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ThemeName = 'nocturna' | 'crema' | 'burgundy';

interface ThemeState {
  theme: ThemeName;
}

interface ThemeActions {
  setTheme: (theme: ThemeName) => void;
}

function getInitialTheme(): ThemeName {
  if (typeof window === 'undefined') return 'nocturna';

  const stored = localStorage.getItem('lyricshub-theme');
  if (stored) {
    try {
      const parsed = JSON.parse(stored);
      const value = parsed?.state?.theme;
      if (value === 'nocturna' || value === 'crema' || value === 'burgundy') {
        return value;
      }
    } catch {
      // ignore parse errors
    }
  }

  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  return prefersDark ? 'nocturna' : 'crema';
}

function applyTheme(theme: ThemeName) {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-theme', theme);
  }
}

const initialTheme = getInitialTheme();
applyTheme(initialTheme);

export const useThemeStore = create<ThemeState & ThemeActions>()(
  persist(
    (set) => ({
      theme: initialTheme,

      setTheme: (theme) => {
        applyTheme(theme);
        set({ theme });
      },
    }),
    {
      name: 'lyricshub-theme',
      onRehydrateStorage: () => {
        return (state: (ThemeState & ThemeActions) | undefined) => {
          if (state?.theme) {
            applyTheme(state.theme);
          }
        };
      },
    },
  ),
);
